export default __webpack_public_path__ + "static/media/Banner2_revamp_Hk.98c3aaed.webp";